const localizationData = {
  needHelpBooking: '19122018-152801-0004',
  needHelp: '05092025-113006-0001',
  call: '02062016-072326-8813',
};

export default localizationData;
